// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2E4R1"};